import React, { useState, useEffect, useLayoutEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import '../styles/bootstrap.min.css';
import '../styles/style.css';
import Footer from '../components/Footer';
import staticlogo from '../assets/images/bg_blue.svg';
import helpcenterimage from '../assets/images/logo_icon_white.svg';
import config from '../config/config';

const AntiSlavery = () => {
  const [title, setTitle] = useState('Loading...');
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [metaTitle, setMetaTitle] = useState('');
  const [metaDescription, setMetaDescription] = useState('');
  const [metaKeywords, setMetaKeywords] = useState('');

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await axios.get(`${config.baseURL}/get-anti-slavery-content`);
        if (response.data.success) {
          const pageContent = response.data.data['page-content'];
          setTitle(pageContent.title || 'No Title');
          setContent(pageContent.content || 'No Content');

          // Set SEO metadata
          const seo = pageContent.seo || {};
          setMetaTitle(seo.meta_title || 'Default Meta Title');
          setMetaDescription(seo.meta_description || 'Default Meta Description');
          setMetaKeywords(seo.meta_keywords || 'default,keywords');
        } else {
          setTitle('Content Not Found');
          setContent('The content you are looking for does not exist.');
        }
      } catch (error) {
        console.error('Failed to fetch content:', error);
        setTitle('Error');
        setContent('Failed to fetch content. Please try again later.');
      } finally {
        setLoading(false); // Set loading to false when done
      }
    };

    fetchContent();
  }, []);

  useLayoutEffect(() => {
    // Update document head with SEO metadata
    document.title = metaTitle || 'Anti-Slavery Policy';
    const metaDescriptionTag = document.querySelector('meta[name="description"]');
    const metaKeywordsTag = document.querySelector('meta[name="keywords"]');
    
    if (metaDescriptionTag) {
      metaDescriptionTag.setAttribute('content', metaDescription || '');
    } else {
      const newMetaDescriptionTag = document.createElement('meta');
      newMetaDescriptionTag.name = 'description';
      newMetaDescriptionTag.content = metaDescription || '';
      document.head.appendChild(newMetaDescriptionTag);
    }

    if (metaKeywordsTag) {
      metaKeywordsTag.setAttribute('content', metaKeywords || '');
    } else {
      const newMetaKeywordsTag = document.createElement('meta');
      newMetaKeywordsTag.name = 'keywords';
      newMetaKeywordsTag.content = metaKeywords || '';
      document.head.appendChild(newMetaKeywordsTag);
    }
  }, [metaTitle, metaDescription, metaKeywords]);

  return (
    <div>
      <div className="static_header_inner">
        <div className="container-fluid">
          <div className="col-md-12">
            <div className="static_header_logo">
              <Link to="/">
                <img src={staticlogo} alt="Static Logo" /> PatreonPass
              </Link>
            </div>
          </div>
        </div>
      </div>

      <section id="help_search" className="help_search help_center_area">
        <div className="help_center">
          <img src={helpcenterimage} alt="Help Center" />
        </div>
        <div className="container">
          <div className="row">
            <div className="help_search_block">
              <h2 className="help_title">{title}</h2>
            </div>
          </div>
        </div>
      </section>

      <section className="inner_static">
        <div className="container">
          <div className="row">
            <div className="page_content_static_help single_trans">
              {loading ? (
                <p>Loading content...</p>
              ) : error ? (
                <p>{error}</p>
              ) : (
                <div dangerouslySetInnerHTML={{ __html: content }} />
              )}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AntiSlavery;
